window.DayJS = require("dayjs");
import customParseFormat from 'dayjs/plugin/customParseFormat';
window.DayJS.extend(customParseFormat)
import "dayjs/locale/et";
window.DayJS.locale("et");